import { AsHeadline } from '#components/HeadlineFont.tsx'
import { OnboardingInfo } from '#views/OnboardingInfo.tsx'

export const Onboarding = () => (
	<OnboardingInfo>
		<h2>Getting started</h2>
		<p>
			If you are new to <AsHeadline>teamstatus.space</AsHeadline>, then{' '}
			<a href="/organizations?onboarding=1" data-testid="onboarding-start">
				let's familiarize yourself with how it works
			</a>
			.
		</p>
	</OnboardingInfo>
)
